import { LaborCostSettings } from '@sdk/labor/types';
import { LaborCostSettingsToApi } from '@sdk/labor/types/apiTypes';
import formatDate from '@sdk/utils/dateFormat/formatDate';

enum LaborNumericKeys {
  holidayRateMultiplier = 'holidayRateMultiplier',
  laborPercent = 'laborPercent',
  overtimeDayMultiplier = 'overtimeDayMultiplier',
  overtimeDayThreshold = 'overtimeDayThreshold',
  overtimeWeekMultiplier = 'overtimeWeekMultiplier',
  overtimeWeekThreshold = 'overtimeWeekThreshold',
  spreadOfHoursPay = 'spreadOfHoursPay',
  spreadOfHoursThreshold = 'spreadOfHoursThreshold',
}

enum LaborDateKeys {
  payrollPeriodStartDate = 'payrollPeriodStartDate',
  payrollPeriodStartDateTwo = 'payrollPeriodStartDateTwo',
}

const getSafeValue = (value?: string | number) =>
  typeof value !== 'undefined' ? Number(value) : 0;

const dateToString = (value?: Date): string | null => {
  if (!value) {
    return null;
  }

  return value instanceof Date ? formatDate(value) : value;
};

export const laborSettingsParser = (laborSettings: LaborCostSettings): LaborCostSettingsToApi => {
  return {
    ...laborSettings,
    [LaborNumericKeys.holidayRateMultiplier]: getSafeValue(laborSettings.holidayRateMultiplier),
    [LaborNumericKeys.laborPercent]: getSafeValue(laborSettings.laborPercent),
    [LaborNumericKeys.overtimeDayMultiplier]: getSafeValue(laborSettings.overtimeDayMultiplier),
    [LaborNumericKeys.overtimeDayThreshold]: getSafeValue(laborSettings.overtimeDayThreshold) * 60,
    [LaborNumericKeys.overtimeWeekMultiplier]: getSafeValue(laborSettings.overtimeWeekMultiplier),
    [LaborNumericKeys.overtimeWeekThreshold]:
      getSafeValue(laborSettings.overtimeWeekThreshold) * 60,
    [LaborNumericKeys.spreadOfHoursPay]: getSafeValue(laborSettings.spreadOfHoursPay),
    [LaborNumericKeys.spreadOfHoursThreshold]:
      getSafeValue(laborSettings.spreadOfHoursThreshold) * 60,
    [LaborDateKeys.payrollPeriodStartDate]: dateToString(laborSettings.payrollPeriodStartDate),
    [LaborDateKeys.payrollPeriodStartDateTwo]: dateToString(
      laborSettings.payrollPeriodStartDateTwo
    ),
  };
};
